import { Fragment } from 'react';
import { CopyAssistDropdownItem } from 'modules/ai/copyAssist/components/dropdown/CopyAssistDropdownItem';
import { CopyAssistDropdownError } from './CopyAssistDropdownError';
import { StyledCopyAssistDivider, StyledCopyAssistDropdownBody } from '../../styles';

interface CopyAssistDropdownBodyContentProps {
  generatedOptions: string[];
  onCopySuggestionClick: (value: any) => void;
  selected: string;
  isLoading: boolean;
  isError?: boolean;
}

export const CopyAssistDropdownBodyContent = ({
  generatedOptions,
  onCopySuggestionClick,
  selected,
  isLoading,
  isError = false,
}: CopyAssistDropdownBodyContentProps) => {
  let BodyContent;

  if (isError) {
    BodyContent = <CopyAssistDropdownError />;
  } else if (isLoading) {
    BodyContent = <CopyAssistDropdownItem optionText={''} isLoading={isLoading} />;
  } else {
    BodyContent = generatedOptions.map((option, index) => {
      const isFirstItem = index === 0;
      const animationDuration = index * 300;
      const isSelected = index.toString() === selected;
      const showDivider = !isLoading && !isFirstItem;

      return (
        <Fragment key={`${index}_${option.slice(0, 5)}`}>
          {showDivider && (
            <StyledCopyAssistDivider style={{ animationDelay: `${animationDuration}ms` }} />
          )}
          <CopyAssistDropdownItem
            style={{ animationDelay: `${animationDuration}ms` }}
            onClick={() => {
              onCopySuggestionClick(index);
            }}
            isSelected={isSelected}
            optionText={option}
            isLoading={isLoading}
          />
        </Fragment>
      );
    });
  }

  return <StyledCopyAssistDropdownBody>{BodyContent}</StyledCopyAssistDropdownBody>;
};
